export const COPY_NONE = '__none__';
/** Copy source weekday to every other day in the grid (Copy To menu). */
export const COPY_ALL_OTHER_DAYS = '__all_other_days__';
export const CUTOFF_DAY_OFFSETS = [0, 1, 2, 3, 4, 5, 6];

/** Persisted per-weekday on `schedule[weekday]` alongside slot booleans. */
export const CUTOFF_KEY = 'cutoff';

/** Default cutoff time stored as top-of-hour only (`HH:00`). */
export const DEFAULT_CUTOFF_TIME = '12:00';

/** Selectable cutoff hours (24h). */
export const CUTOFF_HOUR_RANGE = Array.from({ length: 24 }, (_, i) => i);

export const TIME_LIKE_RE = /^([01]?\d|2[0-3])(?::([0-5]\d))?$/;

export const NON_RECURRING_DURATION = formatMessage => [
  {
    label: formatMessage({ id: 'SINGLE', defaultMessage: 'Single' }),
    value: 'SINGLE',
  },
  {
    label: formatMessage({ id: 'MULTI_DAY', defaultMessage: 'Multi Day' }),
    value: 'RANGE',
  },
];

export const RECURRENCE_PATTERN = formatMessage => [
  {
    label: formatMessage({ id: 'DAILY', defaultMessage: 'Daily' }),
    value: 'DAILY',
  },
  {
    label: formatMessage({ id: 'WEEKLY', defaultMessage: 'Weekly' }),
    value: 'WEEKLY',
  },
  {
    label: formatMessage({ id: 'MONTHLY', defaultMessage: 'Monthly' }),
    value: 'MONTHLY',
  },
  {
    label: formatMessage({ id: 'YEARLY', defaultMessage: 'Yearly' }),
    value: 'YEARLY',
  },
];

export const END_DATE_OPTIONS = formatMessage => [
  {
    label: formatMessage({ id: 'NO_END_DATE', defaultMessage: 'No end date' }),
    value: 'NO_END_DATE',
  },
  {
    label: formatMessage({ id: 'END_BY', defaultMessage: 'End by' }),
    value: 'END_BY',
  },
];

export const WEEK_OF_MONTH_OPTIONS = formatMessage => [
  {
    label: formatMessage({ id: 'FIRST', defaultMessage: 'First' }),
    value: 'FIRST',
  },
  {
    label: formatMessage({ id: 'SECOND', defaultMessage: 'Second' }),
    value: 'SECOND',
  },
  {
    label: formatMessage({ id: 'THIRD', defaultMessage: 'Third' }),
    value: 'THIRD',
  },
  {
    label: formatMessage({ id: 'FOURTH', defaultMessage: 'Fourth' }),
    value: 'FOURTH',
  },
  {
    label: formatMessage({ id: 'LAST', defaultMessage: 'Last' }),
    value: 'LAST',
  },
];

export const FIRST_LAST_WEEK_OF_MONTH_OPTIONS = formatMessage => [
  {
    label: formatMessage({ id: 'FIRST', defaultMessage: 'First' }),
    value: 'FIRST',
  },
  {
    label: formatMessage({ id: 'LAST', defaultMessage: 'Last' }),
    value: 'LAST',
  },
];

export const MAX_WIDTH_HORZ_LAYOUT = '170px';
